import * as go from 'gojs';

import {
  HiddenCategory,
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import {
  DiagramLink,
  DiagramLinkLabel,
  DiagramNode,
  DiagramPart,
} from 'src/containers/ProjectDiagram/types/diagram';

export const isNode = <T extends DiagramNode>(
  obj: go.GraphObject,
  nodeCategory?: NodeCategory
): obj is T =>
  obj instanceof go.Node &&
  (nodeCategory
    ? obj.data?.category === nodeCategory
    : Object.values(NodeCategory).some(
        (category) => obj.data?.category === category
      ));

export const isLinkLabel = <T extends DiagramLinkLabel>(
  obj: go.GraphObject,
  linkLabelCategory?: LinkLabelCategory
): obj is T =>
  obj instanceof go.Node &&
  (linkLabelCategory
    ? obj.data?.category === linkLabelCategory
    : Object.values(LinkLabelCategory).some(
        (category) => obj.data?.category === category
      ));

export const isLink = <T extends DiagramLink>(
  obj: go.GraphObject,
  linkCategory?: LinkCategory
): obj is T =>
  obj instanceof go.Link &&
  (linkCategory
    ? obj.data?.category === linkCategory
    : Object.values(LinkCategory).some(
        (category) => obj.data?.category === category
      ));

export const isHidden = <T extends DiagramPart>(
  obj: go.GraphObject,
  hiddenCategory?: HiddenCategory
): obj is T =>
  obj instanceof go.Part &&
  (hiddenCategory
    ? obj.data?.category === hiddenCategory
    : Object.values(HiddenCategory).some(
        (category) => obj.data?.category === category
      ));
